/**
 * Compass Mum — стилистика мобильного приложения (design/)
 * Мягкий мятно-зелёный акцент, светлый фон, пастельные карточки.
 */
export const appDesign = {
  primary: '#7CB342',
  primaryHover: '#689F38',
  primaryActive: '#558B2F',
  /** Градиент шапки / онбординга */
  gradientTop: '#E8F5E9',
  gradientMid: '#C8E6C9',
  gradientBottom: '#A5D6A7',
  /** Фон страниц */
  pageBg: '#F0F9F4',
  /** Карточки «как в приложении» — голубой оттенок */
  cardTintBlue: '#E3F2FD',
  cardTintGreen: '#E8F5E9',
  text: '#263238',
  textSecondary: '#616161',
  textMuted: '#9E9E9E',
  white: '#FFFFFF',
  headerBar: 'linear-gradient(180deg, #E8F5E9 0%, #DCEDC8 55%, #C5E1A5 100%)',
  shadowSoft: '0 8px 24px rgba(76, 175, 80, 0.08)',
  shadowCard: '0 4px 20px rgba(0, 0, 0, 0.06)',
  radiusLg: 20,
  radiusMd: 16,
  radiusSm: 14,
} as const;
